<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">

    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">TRADE BOARDS</li>
            </ol>
        </nav>
    </div>
    <div class="ms-auto">
        <div class="btn-group">
        </div>
    </div>
</div>
<!--end breadcrumb-->

<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">
                <!-- <div class="form-group">
                    <select class="form-select" [(ngModel)]="selUserId" (change)="onSelUser()">
                        <option *ngFor="let user of users" [value]="user._id"> {{ user.full_name }}</option>
                    </select>
                </div> -->
            </div>
            <div class="col-md-7">
            </div>
            <div class="col-md-3 btn-group">
                <button class="btn btn-primary m-1" (click)="loadTradeboards()">Refresh</button>
                <button class="btn btn-primary m-1" (click)="addTradeboard()">Add</button>
            </div>
        </div>
        <div class="table-responsive mt-3">
            <table class="table align-middle">
                <thead class="table-secondary">
                    <tr class="d-flex">
                        <th class="col-md-6">NAME</th>
                        <th class="col-md-6">ACTION</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let tb of tradeboards" class="d-flex" ng-if="tradeboards.length > 0">
                        <td class="col-md-6">
                            <div>
                                <a>{{ tb.name }}</a>
                            </div>
                        </td>
                        <td class="col-md-6">
                            <div class="table-actions d-flex align-items-center gap-3 fs-6">
                                <i class="bi bi-eye-fill" (click)="openTradeboard(tb)"></i>
                                <button type="button" (click)="deleteTradeboardConfirmation(tb)" class="btn btn-link" data-bs-toggle="modal" data-bs-target="#confirmationModal"><i class="bi bi-trash"></i></button>
                            </div>
                        </td>
                    </tr>
                    <tr class="d-flex" *ngIf="tradeboards.length == 0">
                        <td colspan="6" class="col-md-12 text-center">No Tradeboards Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal fade" id="confirmationModal" tabindex="-1" aria-labelledby="confirmationModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="confirmationModalLabel">Confirmation</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                Are you sure want to delete the tradeboard {{ confirmation_params.tag }}?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="deleteTradeboard()">Delete</button>
            </div>
        </div>
    </div>
</div>